import { render, staticRenderFns } from "./ProrataDiscount.vue?vue&type=template&id=5bfcc3fe&scoped=true&"
import script from "./ProrataDiscount.vue?vue&type=script&lang=ts&"
export * from "./ProrataDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./ProrataDiscount.vue?vue&type=style&index=0&id=5bfcc3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcc3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
